import { BrandedImageryProps } from './branded-imagery.config';

const BrandedImagery = ({ lineWidth }: BrandedImageryProps) => {
  const style = lineWidth ? { width: lineWidth } : undefined;

  return (
    <div data-testid="branded-imagery" className="snowflake-branded-imagery">
      <div className="snowflake-branded-imagery-indicator" style={style} />
    </div>
  );
};

export default BrandedImagery;
